import Vue from "vue";
import VueRouter from "vue-router";

const Login = () => import("../views/login.vue"); //登录
const PrivacyAuthorization = () => import("../views/privacyAuthorization.vue"); //隐私同意页面
const Main = () => import("../views/main.vue"); // 主页面
const MY = () => import("../views/main/my.vue"); //我的
const Shopping = () => import("../views/main/shopping.vue"); //商城
const RedPacket = () => import("../views/main/redPacket.vue"); //红包 页面
const PremiumPrivilege = () => import("../views/main/premiumPrivilege.vue"); //红包 页面
const Withdrawal = () => import("../views/main/withdrawal.vue"); //兑换页面
const WithdrawalRules = () => import("../views/main/withdrawalRules.vue"); //兑换规则页面
const RealNameAuth = () => import("../views/main/realNameAuth.vue"); //实名认证页面
const DedicatedSupport = () => import("../views/main/dedicatedSupport.vue"); //专属客服页面
const Suggestions = () => import("../views/main/suggestions.vue"); //投诉建议页面
const AliPaySuccess = () => import("../views/main/aliPaySuccess.vue"); //支付宝支付成功页面
const AgreeLogin = () => import("../views/agreeLogin.vue"); //用户隐私协议
const CustomerService = () => import("../views/customerService.vue"); //客服添加弹窗
const OfficialSite = () => import("../views/officialSite.vue"); //官网
const ResetPwd = () => import("../views/main/resetPwd.vue"); //修改密码页面
const Pay = () => import("../views/main/pay.vue"); //商品支付页面
const Homepage = () => import("../views/homepage.vue"); //落地页  提供下载地址
const LandingPage = () => import("../views/landingPage.vue"); //落地页  需要给支付过审

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    component: Login,
    meta: { isPublic: true },
  },
  {
    path: "/privacyAuthorization",
    component: PrivacyAuthorization,
    meta: { isPublic: true },
  },
  {
    path: "/homepage",
    component: Homepage,
    meta: { isPublic: true },
  },
  {
    path: "/landingPage",
    component: LandingPage,
    meta: { isPublic: true },
  },
  {
    path: "/main",
    component: Main,
    children: [
      {
        path: "/",
        redirect: "MY",
      },
      {
        path: "/my",
        component: MY,
      },
      {
        path: "/shopping",
        component: Shopping,
      },
      {
        path: "/redPacket",
        component: RedPacket,
      },
      {
        path: "/premiumPrivilege",
        component: PremiumPrivilege,
      },
      {
        path: "/dedicatedSupport",
        component: DedicatedSupport,
      },
      {
        path: "/suggestions",
        component: Suggestions,
      },
    ],
  },
  {
    path: "/withdrawal",
    component: Withdrawal,
  },
  {
    path: "/withdrawalRules",
    component: WithdrawalRules,
  },
  {
    path: "/realNameAuth",
    component: RealNameAuth,
    meta: { isPublic: true },
  },
  {
    path: "/aliPaySuccess",
    component: AliPaySuccess,
    meta: { isPublic: true },
  },
  {
    path: "/agreeLogin",
    component: AgreeLogin,
    meta: { isPublic: true },
  },
  {
    path: "/customerService",
    component: CustomerService,
    meta: { isPublic: true },
  },
  {
    path: "/officialSite",
    component: OfficialSite,
    meta: { isPublic: true },
  },
  {
    path: "/resetPwd",
    component: ResetPwd,
  },
  {
    path: "/pay",
    component: Pay,
  },
  {
    path: "/",
    redirect: "login",
  },
];
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic && !localStorage.getItem("SdkAuthorization")) {
    Vue.prototype.$toast.fail({
      message: "您已退出或登录信息失效，请重新登录",
    });
    return next("/login");
  }
  next();
});
router.afterEach((to, from) => {
  // to: 即将进入的路由对象（目标路由）
  // from: 当前导航正要离开的路由对象（来源路由）
  console.log("路由变化:", `从 ${from.path} 跳转到 ${to.path}`, to);
});
export default router;
